module.exports = __webpack_public_path__ + "static/media/logo2.1fa3f79e.svg";